export default "__VITE_ASSET__f9150618__"